"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useDynamicValues_1 = require("./useDynamicValues");
exports.FeatureFlag = function (_a) {
    var name = _a.name, on = _a.on, off = _a.off, context = _a.context;
    var interpreter = useDynamicValues_1.useDynamicValues();
    return interpreter.featureFlag(name, on, off, context);
};
exports.FeatureFlag.displayName = 'FeatureFlag';
